module.exports = __webpack_public_path__ + "img/Butterfly_00111.49de0116.png";